import { createContext, useContext } from "react";

export const StorageContext = createContext();

export const useStorage = () => useContext(StorageContext);
